function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTopD(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1280 720",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "top_d") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Bg"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6000000000000001
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "180.77 551.96 258.04 412.13 372.11 342.21 406.2 272.78 471.47 139.83 614.98 0 0 0 0 720 156.47 720 180.77 551.96",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "614.98 0 703.29 77.27 712.16 88.63 712.16 88.63 795.28 195.03 816.42 272.78 898.32 574.04 1041.82 695.47 1050.86 720 1280 720 1280 0 614.98 0",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "712.16 88.63 703.29 77.27 614.98 0 687.66 63.6 712.16 88.63",
    style: {
      fill: "#444"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "524.01 88.63 614.98 0 471.47 139.83 524.01 88.63",
    style: {
      fill: "#444"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "406.2 272.78 406.2 272.78 581.46 370.43 483.41 315.8 406.2 272.78",
    style: {
      fill: "#444"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "865.5 720 942.6 720 937.57 697.51 921.21 648.45 819.81 565.04 885.23 681.16 865.5 720",
    style: {
      fill: "#262626"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "921.21 648.45 937.57 697.51 942.6 720 1050.86 720 1041.82 695.47 819.81 565.04 921.21 648.45",
    style: {
      fill: "#252525"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "725.37 607.15 692.34 720 793.91 720 725.37 607.15",
    style: {
      fill: "#222"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "789.15 517.62 819.81 565.04 1041.82 695.47 898.32 574.04 780.56 463.65 789.15 517.62",
    style: {
      fill: "#2b2b2b"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "865.5 720 885.23 681.16 819.81 565.04 829.07 720 865.5 720",
    style: {
      fill: "#242424"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "580.32 720 592.9 674.62 601.48 607.15 543.98 720 580.32 720",
    style: {
      fill: "#202020"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "816.42 272.78 795.28 195.03 816.42 272.78 816.42 272.78",
    style: {
      fill: "#363636"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "816.42 272.78 795.28 195.03 787.92 225.69 816.42 272.78",
    style: {
      fill: "#363636"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "898.32 574.04 816.42 272.78 816.42 272.78 898.32 574.04",
    style: {
      fill: "#323232"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "787.92 285.79 737.63 272.78 776.27 444.56 780.56 463.65 898.32 574.04 816.42 272.78 787.92 285.79",
    style: {
      fill: "#323232"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "795.28 195.03 712.16 88.63 712.16 88.63 795.28 195.03",
    style: {
      fill: "#3d3d3d"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "720.46 121.43 720.46 166.81 744.99 176.63 787.92 225.69 795.28 195.03 712.16 88.63 720.46 121.43",
    style: {
      fill: "#3d3d3d"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "638.89 56.42 687.66 63.6 614.98 0 614.98 40.48 638.89 56.42",
    style: {
      fill: "#414141"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "638.89 423.41 601.48 607.15 592.9 674.62 580.32 720 692.34 720 725.37 607.15 793.91 720 829.07 720 819.81 565.04 789.15 517.62 780.56 463.65 776.27 444.56 638.89 423.41",
    style: {
      fill: "#2c2c2c"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "780.56 463.65 776.27 444.56 776.27 444.56 780.56 463.65",
    style: {
      fill: "#2c2c2c"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "629.7 361.84 638.89 423.41 776.27 444.56 737.63 272.78 675.08 258.81 629.7 361.84",
    style: {
      fill: "#343434"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "776.27 444.56 737.63 272.78 776.27 444.56 776.27 444.56",
    style: {
      fill: "#343434"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "816.42 272.78 816.42 272.78 816.42 272.78 816.42 272.78",
    style: {
      fill: "#353535"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "712.16 225.69 675.08 258.81 737.63 272.78 787.92 285.79 816.42 272.78 816.42 272.78 787.92 225.69 761.96 233.9 712.16 225.69",
    style: {
      fill: "#353535"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "568.37 114.07 575.73 74.82 594.12 52.74 638.89 56.42 614.98 40.48 614.98 0 524.01 88.63 568.37 114.07",
    style: {
      fill: "#404040"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "787.92 225.69 744.99 176.63 720.46 166.81 761.96 233.9 787.92 225.69",
    style: {
      fill: "#373737"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "712.16 88.63 712.16 88.63 712.16 88.63 712.16 88.63",
    style: {
      fill: "#3e3e3e"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "638.89 56.42 666.49 74.82 694.7 120.2 720.46 166.81 720.46 121.43 712.16 88.63 712.16 88.63 687.66 63.6 638.89 56.42",
    style: {
      fill: "#3e3e3e"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "712.16 225.69 761.96 233.9 720.46 166.81 694.7 120.2 666.49 74.82 638.89 56.42 594.12 52.74 575.73 74.82 568.37 114.07 675.08 258.81 712.16 225.69",
    style: {
      fill: "#3f3f3f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "180.77 551.96 156.47 720 206.51 720 180.77 551.96",
    style: {
      fill: "#282828"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "244.31 720 321.82 542.15 325.91 401.5 180.77 551.96 206.51 720 244.31 720",
    style: {
      fill: "#2e2e2e"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "557.33 551.96 362.3 650.82 347.27 720 538.15 720 557.33 551.96",
    style: {
      fill: "#272727"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "538.15 720 539.4 720 568.37 574.04 618.66 463.65 601.48 607.15 638.89 423.41 629.7 361.84 581.46 370.43 549.97 409.68 557.33 551.96 538.15 720",
    style: {
      fill: "#2f2f2f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "337.36 668.08 283.24 720 330.38 720 337.36 668.08",
    style: {
      fill: "#1f1f1f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "568.37 574.04 539.4 720 543.98 720 601.48 607.15 618.66 463.65 568.37 574.04",
    style: {
      fill: "#292929"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "557.33 551.96 549.97 409.68 375.79 592.85 362.3 650.82 557.33 551.96",
    style: {
      fill: "#2d2d2d"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "347.27 720 362.3 650.82 375.79 592.85 337.36 668.08 330.38 720 347.27 720",
    style: {
      fill: "#232323"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "629.7 361.84 607.62 246.54 536.48 166.81 524.01 88.63 471.47 139.83 581.46 370.43 629.7 361.84",
    style: {
      fill: "#3b3b3b"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "607.62 246.54 629.7 361.84 675.08 258.81 568.37 114.07 524.01 88.63 536.48 166.81 607.62 246.54",
    style: {
      fill: "#3a3a3a"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "471.47 139.83 406.2 272.78 406.2 272.78 471.47 139.83",
    style: {
      fill: "#393939"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "483.41 315.8 471.47 139.83 406.2 272.78 483.41 315.8",
    style: {
      fill: "#393939"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "581.46 370.43 471.47 139.83 483.41 315.8 581.46 370.43",
    style: {
      fill: "#383838"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "372.11 342.21 258.04 412.13 180.77 551.96 325.91 401.5 372.11 342.21",
    style: {
      fill: "#303030"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "406.2 272.78 372.11 342.21 406.2 272.78 406.2 272.78",
    style: {
      fill: "#313131"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "321.82 542.15 244.31 720 283.24 720 337.36 668.08 375.79 592.85 549.97 409.68 581.46 370.43 406.2 272.78 372.11 342.21 325.91 401.5 321.82 542.15",
    style: {
      fill: "#313131"
    }
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTopD);
export default __webpack_public_path__ + "static/media/top_d.05c2c5226a22185d2d244d2d0200afbf.svg";
export { ForwardRef as ReactComponent };